import XIcon from "../images/close-x.svg?react";

/**Default: 24px by 24px */
export default function CoreXIcon({
	height = 24,
	width = 24,
	color = "#42296E",
}: {
	width?: string | number;
	height?: string | number;
	/**@default "#42296E" */
	color?: string;
}) {
	return <XIcon width={width} height={height} color={color} />;
}
